module.exports = __webpack_public_path__ + "img/resource-tech-image-74.c5f962bf.jpg";